module.exports = __webpack_public_path__ + "img/mystery.bed7084b.png";